import kamala from '../../kamala'
import Image from './Image'

Image.install = function (Vue) {
  kamala(Vue)
  Vue.component(Image.name, Image)
}

export default Image
